<template>
  <div>
    <md-table :value="members" md-sort="name" md-sort-order="asc" md-card md-fixed-header>
      <md-table-toolbar> <div class="md-toolbar-section-start">
          <md-button class="md-raised md-primary" @click="newMember">New Member</md-button>
        </div>

        <md-field md-clearable class="md-toolbar-section-end">
          <md-input placeholder="Search by name..." v-model="search" @input="searchOnTable" />
        </md-field>
      </md-table-toolbar>

      <md-table-empty-state
        md-label="No users found"
        :md-description="`No members found for this '${search}' query. Try a different search term or create a new member.`">
        <md-button class="md-primary md-raised" @click="newMember">Create New Member</md-button>
      </md-table-empty-state>

      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="Name" md-sort-by="name">{{ item.first_name }} {{ item.last_name }}</md-table-cell>
        <md-table-cell md-label="Email" md-sort-by="email">{{ item.email }}</md-table-cell>
        <md-table-cell md-label="Visited" md-sort-by="visited"><md-icon v-if="item.handbook && item.handbook.visited">done</md-icon><md-tooltip md-direction="bottom" v-if="item.handbook && item.handbook.visited">{{ item.handbook.visited | displayDate }}</md-tooltip></md-table-cell>
        <md-table-cell md-label="Signed" md-sort-by="signed"><md-icon v-if="item.handbook && item.handbook.signature && item.handbook.signature.signed">done</md-icon><md-tooltip md-direction="bottom" v-if="item.handbook && item.handbook.signature && item.handbook.signature.signed">{{ item.handbook.signature.signed | displayDate }}</md-tooltip></md-table-cell>
      </md-table-row>
    </md-table>

    <md-dialog :md-active.sync="showMemberDialog">
      <md-dialog-title>Member</md-dialog-title>
      <form class="md-layout">
        <div class="md-layout-item md-layout member-dialog-content">
          <div class="md-layout-item md-size-100">
            <md-field :class="getValidationClass('first_name')"> 
              <label for="first-name">First Name</label>
              <md-input name="first-name" id="first-name" autocomplete="given-name" v-model="form.first_name" :disabled="sending" />
                <span class="md-error" v-if="!$v.form.first_name.required">The first name is required</span>
            </md-field>
          </div>

          <div class="md-layout-item md-size-100">
            <md-field :class="getValidationClass('last_name')">
              <label for="last-name">Last Name</label>
              <md-input name="last-name" id="last-name" autocomplete="family-name" v-model="form.last_name" :disabled="sending" />
                <span class="md-error" v-if="!$v.form.last_name.required">The last name is required</span>
            </md-field>
          </div>

          <div class="md-layout-item md-size-100">
            <md-field :class="getValidationClass('email')">
              <label for="email">Email</label>
              <md-input type='email' name="email" id="email" autocomplete="email" v-model="form.email" :disabled="sending" />
                <span class="md-error" v-if="!$v.form.email.required">The email is required</span>
                <span class="md-error" v-else-if="!$v.form.email.email">Invalid email</span>
            </md-field>
          </div>
        </div>
      </form>

      <md-dialog-actions>
        <md-button class="md-primary" @click="showMemberDialog = false">Close</md-button>
        <md-button class="md-primary" @click="createMember">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters} from 'vuex'
import moment from 'moment'
import { validationMixin } from 'vuelidate'
import {
  required,
  email
} from 'vuelidate/lib/validators'

export default {
  name: 'TableSearch',
  mixins: [validationMixin],
  data: () => ({
    sending: false,
    search: null,
    showMemberDialog: false,
    form: {
      first_name: '',
      last_name: '',
      email: ''
    }
  }),
  validations: {
    form: {
      first_name: {
        required
      },
      last_name: {
        required
      },
      email: {
        required,
        email
      }
    }
  },
  computed: {
    ...mapState({
      user: s => s.auth.user
    }),
    ...mapGetters([
      'filteredMembers'
    ]),
    members: function() {
      return this.filteredMembers.filter( m => m.id != this.user.user_id )
    }
  },
  filters: {
    displayDate: function (date) {
      if(date){
        return moment.parseZone(date).format('YYYY-MM-DD HH:mm:ss')
      }else {
        return ''
      }
    }
  },
  methods: {
    ...mapActions([
      'fetchMembers',
      'searchMembers',
      'saveMember'
    ]),
    newMember () {
      this.$v.$reset()
      this.showMemberDialog = true
    },
    searchOnTable () {
      this.searchMembers(this.search)
    },
    createMember() {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.saveMember(this.form)
        this.showMemberDialog = false
      }
    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]
      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    }
  },
  created () {
    console.log("Fetch Members")
    this.fetchMembers()
  }

}
</script>

<style lang="scss" scoped>
.md-field {
  max-width: 300px;
}
.md-dialog {
  min-width: 480px;
  max-width: 768px;
}
.member-dialog-content {
  padding: 32px;
}
</style>
